<template>
  <div
    class="d-flex range-wrap"
    :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'"
  >
    <!-- SELECT RANGE -->
    <div class="flex-grow-1 px-2 pb-3">
      <v-select
        v-model="select"
        :items="items"
        item-text="label"
        item-value="value"
        :label="$t('breaks')"
        hide-details
        solo-inverted
        return-object
        prepend-icon="mdi-calendar-range"
        dense
        :disabled="disabledRangeSelect"
      ></v-select>
    </div>

    <!-- RANGE MENU - 1 - DATA_INÍCIO -->
    <div
      v-if="!hideRangeMenu"
      class="d-flex flex-grow-1 px-2 pb-3"
    >
      <v-menu
        v-model="menu1"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :nudge-right="40"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="dateStartBr"
            label=""
            prepend-icon="mdi-calendar-today  "
            :prefix="$t('from')"
            readonly
            solo-inverted
            hide-details
            dense
            :disabled="disabledRange"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="data_inicio"
          @input="menu1 = false"
        ></v-date-picker>
      </v-menu>
      <v-text-field
        v-show="showTime"
        v-model="time_inicio"
        :disabled="disabledRange"
        label="hh:mm:ss"
        solo-inverted
        dense
        class="ml-2"
        :hide-details="hideDetails"
        :error="!hideDetails"
        :error-messages="errorTime"
        v-mask="'##:##:##'"
      >
      </v-text-field>
    </div>

    <!-- RANGE MENU - 2 - DATA_FINAL -->
    <div
      v-if="!hideRangeMenu"
      class="d-flex flex-grow-1 px-2 pb-3"
    >
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :nudge-right="40"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="dateEndBr"
            label=""
            prepend-icon="mdi-calendar"
            :prefix="$t('until')"
            readonly
            solo-inverted
            hide-details
            dense
            :disabled="disabledRange"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="data_final"
          @input="menu2 = false"
          :min="limitRangeDate.min"
          :max="limitRangeDate.max"
        ></v-date-picker>
      </v-menu>
      <v-text-field
        v-show="showTime"
        v-model="time_final"
        :disabled="disabledRange"
        label="hh:mm:ss"
        solo-inverted
        dense
        class="ml-2"
        :hide-details="hideDetails"
        :error="!hideDetails"
        :error-messages="errorTime"
        v-mask="'##:##:##'"
      >
      </v-text-field>
    </div>
  </div>
</template>
<script>
Date.prototype.substractDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() - days);
  return date;
}

export default {
  name: "components-common-range-rangedate",
  data: () => ({
    data_inicio_br: "",
    data_final_br: "",
    limitRangeDate: {
      min: "",
      max: "",
    },
    items: [],
    // SELECT:
    select: {
      label: "Hoje",
      value: "today",
    },

    // CALENDAR MENU RANGE:
    hideRangeMenu: false,
    data_inicio: "",
    data_final: "",
    menu1: false,
    menu2: false,
    disabledRangeSelect: false,
    time_inicio: "",
    time_final: "",
    errorTime: "",
    hideDetails: true,

    showTime: true,
  }),
  mounted() {
    // console.log("mounted");
    // Meta dado inserido no router (Ex. /dashboard)
    this.hideRangeMenu = this.$route.meta.hideRangeMenu;

    this.weeklyDealHandle();
    const selectRangeDays = {
      7: this.itemsWeek,
      15: [...this.itemsWeek, ...this.itemsHalfMonth],
      31: [...this.itemsWeek, ...this.itemsHalfMonth, ...this.itemsMonth],
    };
    this.items =
      selectRangeDays[this.$route.meta.filterLimitDays] || selectRangeDays[7];
    this.select = this.selectHandle();
    // this.select = this.selectTranslate;

    if (this.$route.meta.isDash) {
      // Retira a opção "Today", "Mês atual" e "Mês passado" do array de opções
      this.items.shift();
      this.items.pop();
      this.items.pop();
      this.select = this.itemsWeek[2];
    }

    if (
      this.$route.name == "AdministratorAffiliatesCpa" ||
        this.$route.name == "CollaboratorAffiliatesCpa" ||
          this.$route.name == "RegionalManagerAffiliatesCpa" ||
            this.$route.name == "LocalManagerAffiliatesCpa" ||
              this.$route.name == "AdministratorReportsCasinoBets" ||
                this.$route.name == "ColabReportsCasinoBets"
    ) {
      // Retira a opção "Today"
      this.items.shift();
      this.select = this.itemsWeek[1];
    }
  },
  computed: {
    itemsWeek() {
      return [
        {
          label: this.$t("today"),
          value: "today",
        },
        {
          label: this.$t("yesterday"),
          value: "yesterday",
        },
        {
          label: this.$t("lastSevenDays"),
          value: "lastSevenDays",
        },
        {
          label: this.$t("currentWeek"),
          value: "currentWeek",
        },
        {
          label: this.$t("lastWeek"),
          value: "lastWeek",
        },
      ];
    },
    itemsHalfMonth() {
      return [
        {
          label: this.$t("halfMonth"),
          value: "halfMonth",
        },
      ];
    },
    itemsMonth() {
      return [
        {
          label: this.$t("currentMonth"),
          value: "currentMonth",
        },
        {
          label: this.$t("lastMonth"),
          value: "lastMonth",
        },
      ];
    },
    // Recuperando o Range armazenado no Store.
    rangeDate() {
      // console.log("Computed: rangeDate");
      return this.$store.state.range.date;
    },
    dateStartBr() {
      // console.log("Computed: dateStartBr");
      return this.$store.state.range.date_start_br;
    },
    dateEndBr() {
      // console.log("Computed: dateEndBr");
      return this.$store.state.range.date_end_br;
    },
    timeStart() {
      // console.log("Computed: timeStart");
      return this.$store.state.range.time_start;
    },
    timeEnd() {
      // console.log("Computed: timeEnd");
      return this.$store.state.range.time_end;
    },
    disabledRange() {
      // console.log("Computed: disabledRange");
      return this.$store.state.range.disabled;
    },
    // Recuperando o Select
    selectDate() {
      // console.log("Computed: selectDate");
      return this.$store.state.range.select;
    },
    // Get no result bet
    // Pendentes 3, Perdidas 0, Premiadas 1
    selectResultBet() {
      // console.log("Computed: selectResultBet");
      return this.$store.state.filters.selectResultBet.result;
    },

    CRONRoutes() {
      return this.$route.name == "AdministratorReportsCasinoBets" ||
        this.$route.name == "ColabReportsCasinoBets";
    }
  },
  watch: {
    // Quando desabilita o RangeDate, remove os Iputs de Time
    disabledRange(val) {
      if (!val) {
        this.showTime = true;
      } else {
        this.showTime = false;
      }
    },
    rangeDate(val) {
      // console.log("watch rangeDate");
      // console.log(val);
      val && this.buildRangeUI();
    },

    // Se os dois menus estiverem preenchido
    // pode setar no store o range.
    data_inicio(val) {
      // console.log("watch data_inicio");
      // console.log(val);
      if (val && this.data_final != "") {
        this.setRangeStore();
      }
    },

    // Se os dois menus estiverem preenchido
    // pode setar no store o range.
    data_final(val) {
      // console.log("watch data_final");
      // console.log(val);
      if (val && this.data_inicio != "") {
        this.setRangeStore();
      }
    },

    time_inicio(val) {
      // console.log("watch time_inicio");
      // console.log(val);
      // if (!val) return;
      if (val.length == 8) {
        this.timeValidated(val);
      }
    },

    time_final(val) {
      // console.log("watch time_final");
      // console.log(val);
      // if (!val) return;
      if (val.length == 8) {
        this.timeValidated(val);
      }
    },

    timeStart(val) {
      // console.log("watch timeStart");
      // console.log(val);
      this.time_inicio = val;
    },

    timeEnd(val) {
      // console.log("watch timeEnd");
      // console.log(val);
      this.time_final = val;
    },

    selectResultBet(val) {
      // console.log("watch selectResultBet");
      // console.log(val);
      if (
        this.$localStorage.getItem("level", "string") != "administrator" ||
        this.$route.name != "AdministratorBetList"
      )
        return;
      this.disabledRangeSelect = val == 0 ? true : false;
      this.setRangeStore();
    },

    // Mantendo o Select Sincronizado com os menus date picker
    async select(select) {
      // console.log("watch select");
      // console.log(select);
      if (select == null) return;
      // console.log("watch select - 2");

      this.$store.commit("setDisabledRange", false);
      this.$store.commit("SetRangeSelect", select);

      var rangeDate;
      // if (select.value === "weekly_deal") {
      //   // console.log(select)
      //   this.$store.commit("setDisabledRange", true);
      //   rangeDate = await this.$date.get[select.value]();
      //   this.$store.commit("SetRangeDate", rangeDate);
      //   return;
      // }

      // Escopo if acima substituido pelo escopo abaixo, para incluir
      // "Apuração Atual" de maneira que não fosse preciso copiar código
      // e reaproveitar parte do código já existente.

      var deals = [
        {
          text: "weekly_deal",
          value: 1,
        },
        {
          text: "current_deal",
          value: 2,
        },
      ];
      let deal = deals.find((item) => {
        return item.text == select.value;
      });

      if (deal) {
        this.$store.commit("setDisabledRange", true);
        rangeDate = await this.$date.get["allDeals"](deal.value);
        this.$store.commit("SetRangeDate", rangeDate);
        return;
      }

      // Reset
      this.$store.commit("SetRangeDate", { data_inicio: "", data_final: "" });
      this.$store.commit("SetTimeStart", "");
      this.$store.commit("SetTimeEnd", "");
      this.data_final = "";
      this.data_inicio = "";
      // this.time_inicio = "";
      // this.time_final = "";

      // Get Range
      rangeDate = await this.$date.get[select.value]();

      // Tratamentos rotas com CRON
      // Mês atual
      if (this.CRONRoutes && select.value == "currentMonth") {
        rangeDate.data_final = new Date(new Date().setHours(this.$gmtHour(), 59, 59)).substractDays(1).toISOString().slice(0, -1);
      }
      // Últimos 15 dias
      if (this.CRONRoutes && select.value == "halfMonth") {
        rangeDate.data_final = new Date(new Date().setHours(this.$gmtHour(), 59, 59)).substractDays(1).toISOString().slice(0, -1);
      }

      // Date
      this.data_inicio = rangeDate.data_inicio.slice(0, -13);
      this.data_final = rangeDate.data_final.slice(0, -13);

      // Configuration to toLocaleTimeString
      // Time all return 00:00:00 or 23:59:59
      let options = {
        second: "2-digit",
        minute: "2-digit",
        hour: "2-digit",
        hourCycle: "h23",
      };
      // Time
      this.time_inicio = new Date(rangeDate.data_inicio).toLocaleTimeString(
        navigator.language,
        options
      );
      this.time_final = new Date(rangeDate.data_final).toLocaleTimeString(
        navigator.language,
        options
      );
    },

    // SETUP change route:
    $route() {
      // Meta dado inserido no router (Ex. /dashboard)
      this.hideRangeMenu = this.$route.meta.hideRangeMenu;

      this.weeklyDealHandle();

      // this.select = this.selectDate;
      const selectRangeDays = {
        7: this.itemsWeek,
        15: [...this.itemsWeek, ...this.itemsHalfMonth],
        31: [...this.itemsWeek, ...this.itemsHalfMonth, ...this.itemsMonth],
      };
      this.items =
        selectRangeDays[this.$route.meta.filterLimitDays] || selectRangeDays[7];
      this.select = this.selectHandle();

      this.disabledRangeSelect =
        this.$route.name == "AdministratorBetList" && this.selectResultBet == 0
          ? true
          : false;

      if (
        this.$route.name == "AdministratorAffiliatesCpa" ||
          this.$route.name == "CollaboratorAffiliatesCpa" ||
            this.$route.name == "RegionalManagerAffiliatesCpa" ||
              this.$route.name == "LocalManagerAffiliatesCpa" ||
              this.$route.name == "AdministratorReportsCasinoBets" ||
              this.$route.name == "ColabReportsCasinoBets"
      ) {
        // Retira a opção "Today"
        this.items.shift();
        this.select = this.itemsWeek[1];
      }
    },
  },
  methods: {
    timeValidated(time) {
      // console.log("method: timeValidated");

      if (time > "23:59:59") {
        this.errorTime = this.$t("invalidTime");
        this.hideDetails = false;
        this.$store.commit("DisabledSave", true);
        return;
      }

      this.$store.commit("DisabledSave", false);
      this.errorTime = "";
      this.hideDetails = true;

      // Quando Selecionado "Apuração Semanal"
      // Não executar a validação de Time
      // Porque ele já vem do banco de dados correto.
      // E evita erro na UI principalmente
      // quando executa this.setRangeStore() dentro
      // desse escopo.
      if (this.rangeDate.weekly_deal || this.rangeDate.current_deal) return;
      this.setRangeStore();
    },

    weeklyDealHandle() {
      const retail = localStorage.getItem("operator-retail");
      // Remove Apuração Semanal, Apuração Atual para o retail 0 e 1.
      if (retail != 2) return;
      // console.log("method: weeklyDealHandle");
      const routeName = this.$route.name;
      const supportedPages = [
        "AdministratorFinancialSalesReport",
        "RegionalManagerFinancialApuration",
        "LocalManagerFinancialApuration",
        "LocalManagerFinancialApurationAgent",
      ];
      if (supportedPages.includes(routeName)) {
        const weeklyDeal = {
          label: this.$t("weeklyCalculation"),
          value: "weekly_deal",
        };
        const currentDeal = {
          label: this.$t("currentCalculation"),
          value: "current_deal",
        };
        this.itemsWeek.splice(1, 0, weeklyDeal, currentDeal);
      } else if (
        this.itemsWeek.some(
          (item) => item.value === "weekly_deal" && "current_deal"
        )
      ) {
        this.itemsWeek.splice(1, 2);
      }
    },

    // Set limit range
    setLimitRange() {
      // console.log("method: setLimitRange");
      // Set limit range

      // let gmtHour = 23 + Number(this.$gmtShort());

      let max;
      if (
        this.selectResultBet == 0 &&
        this.$route.name == "AdministratorBetList"
      ) {
        max = new Date(
          new Date(this.data_inicio).setHours(this.$gmtHour(), 59, 59)
        )
          .add(1)
          .toISOString();

        this.data_final = this.data_inicio;
      } else {
        max = new Date(
          new Date(this.data_inicio).setHours(this.$gmtHour(), 59, 59)
        )
          .add(this.$route.meta.filterLimitDays || 7)
          .toISOString();
      }

      this.limitRangeDate = { min: this.data_inicio, max };
    },

    // Set Menu Range for Store
    setRangeStore() {
      // console.log("method: setRangeStore");
      // Limite o Range com base na seleção
      this.setLimitRange();

      // Tratamento Data: Inicio e Final
      // var data_inicio = new Date(this.data_inicio).toISOString().slice(0, -1);
      // var data_final = new Date(new Date(this.data_final).setHours(20, 59, 59))
      //   .add(1)
      //   .toISOString()
      //   .slice(0, -1);

      var data_inicio = `${this.data_inicio}T${this.time_inicio}.000`;
      var data_final = `${this.data_final}T${this.time_final}.000`;

      // Se os dois campos tiverem preenchidos armazenar no Store.
      if (data_inicio != "" && data_final != "") {
        this.$store.commit("SetRangeDate", { data_inicio, data_final });
      }
    },

    // Select Handle
    // Mantendo o select Padronizado com
    // a troca de route
    selectHandle() {
      // console.log("method selectHandle");
      if (
        this.items.some((element) => element.value === this.selectDate.value)
      ) {
        return this.selectDate;
      } else {
        return this.itemsWeek[3];
      }
    },

    // Construindo o Range na UI
    buildRangeUI() {
      // console.log("method: buildRangeUI - 1");
      // Tratamento quando o usuário seleciona;
      // 'weekly_deal' (Apuração semanal);
      if (this.rangeDate.weekly_deal) {
        this.showTime = false;
        const week =
          this.rangeDate.weekly_deal == 1
            ? this.$date.get["lastWeek"]()
            : this.$date.get["currentWeek"]();

        let dt_start = new Date(week.data_inicio).toLocaleDateString();
        let dt_end = new Date(week.data_final).toLocaleDateString();
        // Date.prototype.addHours = function(value) {
        //   this.setHours(this.getHours() + value);
        // };
        // dt_end.addHours(1);
        // dt_end = new Date(dt_end).toISOString();
        // dt_end = new Date(dt_end).toLocaleDateString();

        // console.log("tm_start", tm_start)
        // console.log("tm_end", tm_end)
        this.$store.commit("SetDateStartBr", dt_start);
        this.$store.commit("SetDateEndBr", dt_end);
        // Depratated for Build UI
        this.time_inicio = "00:00:00";
        this.time_final = "00:00:00";
        return;
      }
      this.showTime = true;
      // Handle
      var rangeDate = this.rangeDate;
      let dt_start = new Date(rangeDate.data_inicio).toLocaleDateString();
      let dt_end = new Date(rangeDate.data_final).toLocaleDateString();

      // Preenche os Campos "De:" e "Até" na interface;
      this.$store.commit("SetDateStartBr", dt_start);
      this.$store.commit("SetDateEndBr", dt_end);
      // Range UI - Normalmente é recuperado nas views para Impressão e acima dos Resumos
      // Mas pode ter outras utilizadades de exibição nas páginas;
      let rangeUi = `${this.$t("from")} ${dt_start} ${
        this.time_inicio
      } ${this.$t("until")} ${dt_end} ${this.time_final}`;
      this.$store.commit("setRangeUI", rangeUi);
    },
  },
};
</script>
<style scoped>
.range-wrap {
  flex-wrap: wrap;
}
.range-wrap > div {
  flex-basis: 33.3333333333%;
}
</style>
